import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
const services = [{
  num: '01',
  title: 'Branding',
  description: 'Identity systems, logos, and guidelines that hold up everywhere they land.'
}, {
  num: '02',
  title: 'Web design & build',
  description: 'Sites that load fast, read clearly, and turn visitors into customers.'
}, {
  num: '03',
  title: 'Marketing',
  description: 'Launches, social, and content that actually moves the numbers you care about.'
}, {
  num: '04',
  title: 'Creative consulting',
  description: "Direction, positioning, and design strategy when you need an outside perspective that's been here before.",
  wide: true
}];
export function Services() {
  return <section className="sec" data-id="element-217">
      <div className="sec__head" data-id="element-218">
        <h2 data-id="element-219">What we do</h2>
        <p data-id="element-220">Four things, done properly.</p>
      </div>

      <div className="cards" data-id="element-221">
        {services.map((service, index) => <Link to="/#contact" key={index} className={`card ${service.wide ? 'wide' : ''}`} aria-label={`${service.title} — start a project`} data-id="element-222">
            {!service.wide && <div className="num" data-id="element-223">{service.num}</div>}
            {!service.wide && <div className="arw" data-id="element-224">
                <ArrowUpRight size={20} data-id="element-225" />
              </div>}

            {service.wide ? <>
                <div data-id="element-226">
                  <div className="num mb-2" data-id="element-227">{service.num}</div>
                  <h3 data-id="element-228">{service.title}</h3>
                </div>
                <div className="txt" data-id="element-229">
                  <p data-id="element-230">{service.description}</p>
                </div>
                <div className="arw relative top-0 right-0" data-id="element-231">
                  <ArrowUpRight size={20} data-id="element-232" />
                </div>
              </> : <>
                <h3 data-id="element-233">{service.title}</h3>
                <p data-id="element-234">{service.description}</p>
              </>}
          </Link>)}
      </div>
    </section>;
}